export const ACCOUNT_ENUM = {
    REGISTER: 'REGISTER',
    LOGIN: 'LOGIN',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    OTP: 'OTP',
    SET_PASSWORD: 'SET_PASSWORD',
    DASHBOARD: 'dashboard',
}